/**
 * Pure logic behind DbaRowEditor — lifted out because sound-app has no
 * component-test harness (SOUND-679), so this is the only level it can be pinned.
 */

export const INDUSTRY_OTHER = "Other";

/**
 * Industry choices for a DBA, from the schema's `dbas.industryType` options.
 *
 * The stored value is appended when the schema does not list it. 148 prod DBAs
 * carry a legacy value ("E-commerce" alone is 140, from the Notion import); a
 * select without it would silently show the first option and then save it.
 * Offering it keeps an untouched DBA untouched — the API only validates fields
 * the request changes, so re-saving a legacy value is never sent at all.
 */
export function industryOptions(schema, current) {
  const step = schema?.steps?.find((s) => s.key === "dbas");
  const field = step?.fields?.find((f) => f.name === "industryType");
  const options = [...(field?.options || [])];
  if (current && !options.includes(current)) options.push(current);
  return options;
}

const trimmed = (v) => (typeof v === "string" ? v.trim() : v ?? "");

/**
 * The PUT body for a DBA edit: only keys whose value changed, with a field
 * cleared to empty sent as `null` (the API's "clear it" signal).
 *
 * `industryTypeOther` only means something while industryType is "Other". Moving
 * off "Other" clears it, so a stale free-text answer cannot outlive the choice it
 * described.
 */
export function buildDbaDiff(dba, form, keys) {
  const diff = {};
  const next = { ...form };
  if (next.industryType !== INDUSTRY_OTHER) next.industryTypeOther = "";

  for (const key of [...keys, "industryTypeOther"]) {
    const before = trimmed(dba?.[key]);
    const after = trimmed(next[key]);
    if (after === before) continue;
    if (after === "" && (before === "" || before == null)) continue;
    diff[key] = after === "" ? null : after;
  }
  return diff;
}
